export const environment = {
  production: true,
  homol: true,
  apiUrl: 'https://portal-backend-homolog-k8s.kwikledgers.com/api',
  backendUrl: 'https://portal-backend-homolog-k8s.kwikledgers.com',
  homeSignUrl: 'https://kwikledgers.com',
  termsUrl: 'https://app.termly.io/policy-viewer/policy.html?policyUUID=a99ecf2e-3f16-46c8-9386-7e67e2d4b9c0',
  privacyPolicyUrl: 'https://app.termly.io/document/privacy-policy/dc9b3750-7bd7-4508-b259-19192c8d55be',
  adminUrl: 'https://admin-homolog.kwikledgers.com/',
  accountantUrl: 'https://accountant-homolog.kwikledgers.com/',
  translationFeature: true,
  intercomChatId: 'st8ha049',
  featureIntercomChat: false,
  queueRegisterUserFeature: false,
  klStoreFrontendUrl: 'https://kwik-store-homolog.kwikledgers.com',
  klStoreUrl: 'https://kl-store-api-hml-k8s.kwikledgers.com',
  fileStorageSimpleFileUrl: 'https://file-storage-homolog-k8s.kwikledgers.com',
  stripeElementFeature: true,
  stripeKey: 'pk_test_51L59qAGrsYPkp7F0dGcpL1L74vksBjsE616qeYb0wQAQv7ABwIoX4ONMrGjjKk8i1DaNUY7LNpFFVz9AVT7X1miD005957nGNi',
  annualReportProductName: 'Annual Report',
  kwikledgersSiteUrl: 'https://kwikledgers.com',
  signUpVideoUrl: 'https://www.youtube.com/embed/eBipLlPmKsQ',
  maxFileSize: 26214400, //25M
  hotjarId: 3409363,
  whatsappUrl: 'https://wa.me/',
  growingLedgersSku: 'growing_ledgers_24999',
  coupon850: "Kwikdesconto"
};
